import React, { useState, useEffect } from 'react';
import BlogPostCard from '../../components/BlogPostCard';
import '../../styles/Blog.css';

const BlogPage = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await fetch('/api/blog/posts');
                if (!response.ok) {
                    throw new Error('Failed to fetch blog posts');
                }
                const data = await response.json();
                setPosts(data);

                // SEO: Set title and description
                document.title = 'Blog - WizeHelper';
                let metaDescription = document.querySelector("meta[name='description']");
                if (!metaDescription) {
                    metaDescription = document.createElement('meta');
                    metaDescription.name = 'description';
                    document.head.appendChild(metaDescription);
                }
                metaDescription.content = 'Read the latest tips and insights on Reddit marketing for small businesses.';

            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    if (loading) return <div className="spinner-container"><div className="spinner"></div></div>;
    if (error) return <div className="error">Error: {error}</div>;

    return (
        <main className="mx-auto px-6 py-8" style={{ maxWidth: '88rem' }}>
            <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[var(--color-primary-accent)] via-[#1A535C] to-[var(--color-secondary-accent)] text-white p-4 py-12 md:p-16 mb-12 shadow-2xl shadow-primary/20 flex flex-col justify-center">
                <div className="absolute inset-0 bg-black/40"></div>
                <div className="relative z-10 text-center">
                    <h1 className="text-5xl md:text-7xl font-black tracking-tighter mb-4 leading-none">Expert Tips for Success</h1>
                    <p className="text-xl md:text-2xl max-w-4xl mx-auto text-white/90 leading-relaxed mt-6">
                        Discover proven strategies, insider tips, and actionable insights to grow your business on Reddit.
                    </p>
                </div>
            </div>

            <div className="blog-posts-container mb-24">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
                    {posts.length > 0 ? (
                        posts.map(post => (
                            <BlogPostCard key={post.slug} post={post} />
                        ))
                    ) : (
                        <p>No posts found. Check back soon!</p>
                    )}
                </div>
            </div>
        </main>
    );
};

export default BlogPage;
